/**
 * Country + Aff. Network filter dropdowns for the Offer picker. Pulled out
 * so BinomOfferPicker stays inside the 150-line file budget.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import { SearchableSelect } from '@/components/ui/form/input/SearchableSelect';

import type { PickerFilterOption } from './picker-shared/picker-filter-options';

export interface BinomOfferPickerExtrasProps {
  country: string;
  network: string;
  countryOptions: PickerFilterOption[];
  networkOptions: PickerFilterOption[];
  onCountryChange: (next: string) => void;
  onNetworkChange: (next: string) => void;
}

const BinomOfferPickerExtras: FC<BinomOfferPickerExtrasProps> = ({
  country,
  network,
  countryOptions,
  networkOptions,
  onCountryChange,
  onNetworkChange,
}) => (
  <>
    <div className="min-w-[8rem] flex-1">
      <SearchableSelect
        value={country}
        onChange={(v) => onCountryChange(String(v))}
        options={countryOptions}
        placeholder="All geo"
      />
    </div>
    <div className="min-w-[10rem] flex-1">
      <SearchableSelect
        value={network}
        onChange={(v) => onNetworkChange(String(v))}
        options={networkOptions}
        placeholder="All networks"
      />
    </div>
  </>
);

export default BinomOfferPickerExtras;
